import { render, staticRenderFns } from "./Collection.vue?vue&type=template&id=592e9ca3&lang=pug&"
import script from "./Collection.vue?vue&type=script&lang=js&"
export * from "./Collection.vue?vue&type=script&lang=js&"
import style0 from "./Collection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('592e9ca3')) {
      api.createRecord('592e9ca3', component.options)
    } else {
      api.reload('592e9ca3', component.options)
    }
    module.hot.accept("./Collection.vue?vue&type=template&id=592e9ca3&lang=pug&", function () {
      api.rerender('592e9ca3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/sales-flow-ui/components/Collection.vue"
export default component.exports